const NewPassword = () => {

    return(
        <div></div>
    )
}

export default NewPassword;